import { useLayoutEffect, useState, type RefObject } from 'react';

/** Min container width to show canvas + practice panel side-by-side. */
export const PAS_SPLIT_MIN_WIDTH = 768;

function measureIsWide(node: HTMLElement | null): boolean {
  if (!node) {
    return typeof window !== 'undefined' && window.innerWidth >= PAS_SPLIT_MIN_WIDTH;
  }
  return node.clientWidth >= PAS_SPLIT_MIN_WIDTH;
}

export function usePasSplitLayout(rootRef: RefObject<HTMLElement | null>) {
  const [isWide, setIsWide] = useState(() => measureIsWide(rootRef.current));

  useLayoutEffect(() => {
    const node = rootRef.current;
    if (!node) return undefined;

    const update = () => {
      setIsWide(node.clientWidth >= PAS_SPLIT_MIN_WIDTH);
    };
    update();

    const observer = new ResizeObserver(update);
    observer.observe(node);
    return () => observer.disconnect();
  }, [rootRef]);

  return isWide;
}
